import { mixed, object, string } from "yup"
import { ID } from "../yup.common"
const kycModel = object({
  id: ID,
  kycType: mixed().label("Kyc Type"),
  idNumber: string().label("Kyc ID"),
  photo: string().nullable(),
})
export default kycModel
